import type { MemberSearchResult as RexMemberSearchResult } from '@bufteam/cfacorp_rex-catering.bufbuild_es/cfa/rex/catering/v1/catering_service_pb';
import * as z from 'zod';

import normalizePhone from '../util/normalizePhone';

export const rexMemberToSearchResult = z.transform<RexMemberSearchResult, MemberSearchMember>(
  ({ id, firstName, lastName, primaryEmail, phoneNumber }) => ({
    id,
    firstName,
    lastName,
    primaryEmail,
    phoneNumber: normalizePhone(phoneNumber) ?? '',
  }),
);
